<script>
	import ReviewsComponent from '$components/ReviewsComponent.svelte';
	import PaymentMethods from '$components/PaymentMethods.svelte';
	import { onMount } from 'svelte';
	import { browser } from '$app/environment';
	import WhatsAppButton from '$components/WhatsAppButton.svelte';
	import { isAppUser } from '$stores/isAppUser';

import { flags } from '$stores/flags';
import { auth } from '$lib/auth';
import { unregisterServiceWorkers } from '$lib/unregisterServiceWorker';
	let hasLoaded = false;

	onMount(() => {
		if (!browser) return;

		hasLoaded = true;
	});
        async function logoutClearCache() {
                try {
                        await auth.signOut();
                } catch (err) {
                        console.error("Logout error:", err);
                }
                unregisterServiceWorkers();
                if (window.caches?.keys) {
                        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
                }
                localStorage.clear();
                sessionStorage.clear();
                window.location.replace("/");
        }
</script>

<footer>
	<div class="flex">
		<div class="footer-col">
			<h4>Get Social</h4>

			<ul class="no-format social-links">
				<li>
					<a href="https://www.facebook.com/hotdrawuk">
						<img src="/images/facebook-white.png" alt="Facebook" />
						<span>Facebook</span>
					</a>
				</li>
				<li>
					<a href="https://www.instagram.com/hotdrawuk/?hl=en">
						<img src="/images/instagram-white.png" alt="Instagram" />
						<span>Instagram</span>
					</a>
				</li>
			</ul>

			<br />

			<!-- <h4>Join us on WhatsApp!</h4>
			<WhatsAppButton invertColour={true} /> -->
		</div>
		<div class="footer-col footer-images">
			<div class="flex-col">
				<img class="foot-logo" src="/hd-full-trans.png" alt="Hotdraw UK" />
				<div>
					<ReviewsComponent showText={false} />
				</div>
			</div>
		</div>
		<div class="footer-col">
			<h4>Useful Links</h4>

			<ul class="no-format">
				<li><a target="_self" href="/">Home</a></li>
				<li><a target="_self" href="/prizes">Competitions</a></li>
				<li><a target="_self" href="/login">Log In</a></li>
				<li><a target="_self" href="/login">Register</a></li>
				<li><a target="_self" href="/winners">Winners</a></li>
				<li><a target="_self" href="/rewards">Reward Points</a></li>
				{#if !$isAppUser}
					<li><a target="_self" href="/subscribe">Subscribe &amp; Save</a></li>
				{/if}
			</ul>
		</div>
	</div>
	{#if hasLoaded}
		<div>
			<h4>Be In The Know</h4>

			<div class="klaviyo-form-VSfZAv" />
		</div>
	{/if}

	<div class="footer-bottom">
		<div class="accepted-cards">
			<PaymentMethods />
		</div>
		<div class="flex">
			<!-- <p>Payments Powered by <a href="https://stripe.com/">Stripe</a></p> -->
                        {#if $flags.logout_clear_cache}
                                <button class="logout-clear" on:click={logoutClearCache}>Log out and Clear Cache</button>
                        {/if}
		</div>
	</div>

	<div class="footer-legal">
		<div class="flex">
			<a target="_self" href="/privacy">Privacy policy</a>
			<a target="_self" href="/terms">Terms &amp; conditions</a>
			<a target="_self" href="/use-policy">Acceptable use policy</a>
			<a target="_self" href="/terms-use-policy">Terms of use</a>
		</div>

		<div class="flex">
			<p>HotDraw UK Ltd - Registration Number #12524803</p>
			<p>
				Made by <a href="https://mylah.co" style="color: #ffbd5f !important; font-weight: 700"
					>MYLAH.co</a
				>
			</p>
		</div>
	</div>

	<!-- <a target="_blank" href="https://icons8.com/icon/7697/heart">Heart</a> icon by <a target="_blank" href="https://icons8.com">Icons8</a> -->
</footer>

<style lang="scss">
	footer {
		a,
		p,
		h4 {
			color: #fff;
		}
	}
	footer .flex {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		padding: 40px 1em;
		background-color: #1d4f7a;
		color: #fff;
	}

	.klaviyo-form-VSfZAv {
		max-width: 480px;
		margin: auto;
	}

	footer .footer-col {
		// min-width: 300px;
		width: 100%;
		@media only screen and (min-width: 749px) {
			&:last-of-type {
				text-align: right;
			}
		}
		&.footer-images {
			text-align: center;

			.foot-logo {
				max-height: 160px;
				margin: 20px auto;
			}

			@media only screen and (max-width: 479px) {
				order: 3;

				.flex-col {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;

					.foot-logo {
						max-height: 60px;
					}
					.foot-logo + div {
						padding-left: 20px;
					}
				}
			}
		}
	}

	footer ul li {
		text-align: left;
		// border-bottom: 1px solid #afafaf;
		display: block;
		margin-bottom: 2px;
		padding-bottom: 2px;
	}

	footer ul li a {
		display: block;
		padding: 7px 0;
		font-weight: 500;
	}

	.footer-legal {
		// padding: 0 20px;
		.flex {
			padding: 5px 20px;
			align-items: flex-start;
			border-bottom: 1px solid #f1f1ff;
		}
		a {
			color: #f1f1ff !important;
			text-decoration: none !important;
			margin: 4px 0;
		}
		p {
			// color: #222;
			margin: 0;
			font-size: 0.9rem;
			// padding: 0 5px;
		}
	}

	.social-links {
		a {
			display: flex;
			// justify-content: space-between;
			align-items: center;
		}
		img {
			max-width: 40px;
			margin-right: 20px;
		}
	}

	@media only screen and (max-width: 749px) {
		.footer-col:not(:first-of-type) {
			margin-top: 20px;
		}
	}

	.footer-bottom {
		display: block;
		padding-top: 20px;

                .logout-clear {
                        margin-top: 10px;
                        padding: 6px 12px;
                        font-size: 0.9rem;
                }
		.flex {
			background-color: white;
			padding: 15px;
		}

		p,
		a {
			color: #222;
		}
		a {
			text-decoration: underline;
		}
	}

	@media (min-width: 680px) {
		footer .flex {
			flex-direction: row;
			align-items: flex-start;
			justify-content: space-between;
			padding: 40px 2em;
		}

		footer .footer-col {
			padding: 0 20px;
		}

		footer ul li {
			text-align: unset;
		}
	}
</style>
